import { useQuery } from "@apollo/client";
import { Box, Spinner } from "grommet";
import { useEffect, useState } from "react";
import FlipMove from "react-flip-move";
import { useSearchParams } from "react-router-dom";
import { GET_CHIPS_LEADERBOARD } from "../queries/user_queries";
import ChipsRankListingItem from "./ChipsRankListingItem";
import ErrorMessage from "./Error";
import "./style.css";

interface ChipsUser {
  username: string;
  chips: number;
  inFanclub: boolean;
  broadcaster: string;
}

interface ChipsLeaderboardWidgetProps {
  broadcaster?: string;
}

const ChipsLeaderboardWidget = ({
  broadcaster: broadcasterProp,
}: ChipsLeaderboardWidgetProps = {}) => {
  const [searchParams] = useSearchParams();
  const broadcasterFromQuery = searchParams.get("broadcaster");

  // Use prop if provided, otherwise fall back to query parameter
  const broadcaster = broadcasterProp || broadcasterFromQuery;

  const {
    loading,
    error,
    data: userData,
    startPolling,
  } = useQuery(GET_CHIPS_LEADERBOARD, {
    variables: { broadcaster },
  });

  const [users, setUsers] = useState<ChipsUser[]>([]);

  useEffect(() => {
    startPolling(2000);
  }, []);

  useEffect(() => {
    if (!loading && userData?.getChipsLeaderboard) {
      // Data is already top 5
      setUsers(userData.getChipsLeaderboard);
    }
  }, [userData, loading]);

  if (error) {
    return <ErrorMessage error={error} />;
  }

  if (!userData?.getChipsLeaderboard) {
    return (
      <Box align="center" margin={"large"}>
        <Spinner size="large" />
      </Box>
    );
  }

  const orderedUsers = users
    .slice()
    .sort((a: ChipsUser, b: ChipsUser) => b.chips - a.chips);

  const usersList = orderedUsers.map((user: ChipsUser) => {
    return (
      <ChipsRankListingItem
        users={orderedUsers}
        key={user.username}
        user={user}
      />
    );
  });

  return (
    <Box
      margin={"large"}
      style={{
        transform: "skewY(3deg)",
      }}
    >
      <Box
        align="center"
        margin="xsmall"
        style={{
          fontFamily: "Orbitron",
          fontSize: 30,
          color: "#eddcff",
        }}
      >
        Chips Leaderboard
      </Box>
      <FlipMove duration={1000} staggerDelayBy={300}>
        {usersList}
      </FlipMove>
    </Box>
  );
};

export default ChipsLeaderboardWidget;
